import React from 'react'
import { DatePicker } from "antd";
import Utils from "Utils";
import dayjs from 'dayjs';

export function AntDate({
    fieldName,
    value,
    setFieldValue,
    isRequired = false,
    label = null,
    errors = {},
    touched = {},
    options = {} }) {
    const dateFormat = options.format || "YYYY-MM-DD";
    return (
        <div className="custom-field flex flex-column">
            <div className={`label ${isRequired && 'required'}`}>{label || Utils.convertSnakeCaseToSpace(fieldName)}</div>
            <DatePicker
                name={fieldName}
                {...options}
                format={dateFormat}
                value={value ? dayjs(value) : ''}
                showToday
                onChange={(e => {
                    setFieldValue(fieldName, dayjs(e).format(dateFormat))
                })}
            />
            <div className="error">
                {errors[fieldName] && touched[fieldName] && errors[fieldName]}
            </div>
        </div>


    )
}
